<template>
  <div class="item-cells confirm-serve-info">
    <!-- 服务门店 -->
    <div class="item-layout" v-if="hasStore && !hideServeCompsYunChanJiaTHG">
      <div class="item-common-layout worker-layout">
        <div class="item-common-content">
          <div class="block" @click="showStore">
            <label class="label-ui"> 服务门店 </label>
            <div class="item-cell-bd">
              <div
                class="chooseTime default"
                v-if="!store || !store.store_code"
              >
                请选择服务门店
              </div>
              <div class="chooseTime" v-else>
                <p>{{ store.store_desc }}</p>
                <!-- <div class="iconfont icon-roundclosefill" @click.stop="deleteTime"></div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="icon-arr-r"></div>
      </div>
    </div>
    <!-- 服务人员 -->
    <div class="item-layout" v-show="hasWorker && !hideServeCompsYunChanJiaTHG">
      <div class="item-common-layout worker-layout">
        <div class="item-common-content" @click="showWorker">
          <div class="block worker-pro-name">
            <label class="label-ui"> 服务人员 </label>
            <div class="item-cell-bd">
              <div
                class="choose-person default"
                v-if="!selectedWorker.workerCode"
              >
                {{ tips }}
              </div>
              <div class="choose-person" v-else>
                <div class="avatar">
                  <img
                    :src="selectedWorker.headImage | avatar(68, 68)"
                    alt=""
                  />
                  <!-- <div class="recommend-flag" v-show="selectedWorker.workerCode === recmdUserCode">推荐</div> -->
                </div>
                <p class="name">{{ selectedWorker.workerName }}</p>
                <!-- <userprofile :recmdUserUid="shareUid" :showArrow="false" :user="selectedWorker"></userprofile> -->
              </div>
            </div>
          </div>
          <div
            class="block worker"
            v-if="selectedWorker && selectedWorker.workerCode"
          >
            <label>员工信息</label>
            <ul>
              <li>{{ selectedWorker.userType | userTypeText }}</li>
              <li>{{ selectedWorker.storeName }}</li>
              <li>已服务&nbsp;{{ selectedWorker.servicedTimes }}次</li>
            </ul>
          </div>
        </div>
        <div class="icon-arr-r"></div>
      </div>
    </div>
    <!-- 服务时间 -->
    <div class="item-layout" v-show="hasTime && !hideServeCompsYunChanJiaTHG">
      <div
        class="item-common-layout"
        :class="{ 'has-selected-time-tip': isPopYuesao || isApplianceWash }"
      >
        <div class="item-common-content">
          <div class="block" @click="showCalendar">
            <label class="label-ui">
              {{ isPopYuesao ? '预产期' : '服务时间' }}
            </label>
            <div class="item-cell-bd">
              <!-- <div class="chooseTime default" v-if="hasWorker && selectedWorker && !selectedWorker.workerCode" >请选择</div> -->
              <div class="chooseTime default" v-if="selectedTime === ''">
                {{ isPopYuesao ? '请选择预产期' : '请选择服务时间' }}
              </div>
              <div class="chooseTime" v-else>
                <p>{{ selectedTime }}</p>
                <!-- <div class="iconfont icon-roundclosefill" @click.stop="deleteTime"></div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="icon-arr-r"></div>
        <div class="selected-time-tip" v-if="isPopYuesao">
          *请正确填写预产期，如您在服务完成后未及时核销，系统将在预产期<span
            class="pf-simbold"
            >90天</span
          >后自动确认核销
        </div>
      </div>
    </div>
    <div class="item-layout" v-if="!isMmz">
      <div class="item-common-layout invite-code">
        <label class="label-ui">邀请码<span>(选填)</span></label>
        <input
          type="text"
          placeholder="请输入邀请码"
          v-model="fillIn.inviteCode"
          @blur="toScrollTop"
        />
      </div>
    </div>
    <div class="item-layout user-remark-layout">
      <div class="item-common-layout user-remark">
        <label class="label-ui">备注<span>(选填)</span></label>
        <textarea
          placeholder="请输入您的需求"
          v-model="fillIn.remark"
          @blur="toScrollTop"
          @input="remarkInput"
        ></textarea>
      </div>
    </div>

    <!-- 联营月嫂专用日期选择器，可以显示年月 -->
    <van-popup v-model="datePickerShow" position="bottom">
      <van-datetime-picker
        v-model="datePickerValue"
        type="date"
        title="日期选择"
        :min-date="datePickerMin"
        @confirm="datePickerConfirm"
        @cancel="datePickerShow = false"
      >
      </van-datetime-picker>
    </van-popup>
  </div>
</template>

<script>
import userprofile from '@/components/user/profile_confirm'
import { mapState, mapMutations } from 'vuex'
import { Popup, DatetimePicker } from 'vant'
import { SKUTAG, SKUTAGNEED } from '@/plugins/enum'
import isIOS from '@/plugins/isIOS'
export default {
  inject: {
    changeServicePopTrackParams: {
      default: null
    },
    changeServiceWorkerTrackParams: {
      default: null
    }
  },
  props: {
    shareUid: {
      type: String,
      default: ''
    },
    fillIn: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      inviteCode: '',
      remark: '',
      selectedStore: '',
      datePickerShow: false,
      datePickerMin: new Date(),
      datePickerValue: new Date(),
      isMmz: this.$route.query.mmz == '1'
    }
  },
  computed: {
    ...mapState([
      'workers',
      'selectedWorker',
      'selectedTime',
      'selectedAddress',
      'locationInfo',
      'viewName',
      'selectedCoupon',
      'confirmProduct',
      'confirmCoupons',
      'confirmSelected'
    ]),
    workers_on() {
      let list =
        (this.workers.available && this.workers.available.workerList) || []
      const { store_code } = this.confirmSelected.store
      if (store_code) {
        list = list.filter(item => item.storeCode == store_code)
      }
      return list
    },
    // 是否已选了地址
    isSelectedAddress() {
      return (
        this.selectedAddress.addrid >= 0 ||
        (this.selectedAddress.regionid && this.selectedAddress.regionid !== '')
      )
    },
    // 是否有定位地址
    hasLocation() {
      return this.locationInfo.areaCode && this.locationInfo.areaCode !== ''
    },
    tips() {
      if (
        (this.hasAddress && this.isSelectedAddress) ||
        (this.hasStore && this.store.store_code)
      ) {
        if (this.workers_on.length > 0) {
          return `${this.workers_on.length}位服务人员可供选择`
        } else {
          return '无满足条件的服务人员'
        }
      } else {
        return '请选择服务人员'
      }
    },
    store() {
      return this.confirmSelected && this.confirmSelected.store
    },
    skuTag() {
      return (
        this.confirmProduct &&
        this.confirmProduct.skuInfo &&
        this.confirmProduct.skuInfo.skuTag
      )
    },
    // 2023-08-02 孕产加特惠馆项目
    // 孕产特惠馆自营商家产品不需要服务人员、服务门店、服务时间
    // isNeedServiceMan: 1 需要 / 0 不需要
    hideServeCompsYunChanJiaTHG() {
      return (
        [SKUTAG.SELFSTORE, SKUTAG.SELFHOME].includes(this.skuTag) &&
        this.confirmProduct &&
        this.confirmProduct.skuInfo &&
        this.confirmProduct.skuInfo.isNeedServiceMan === 0
      )
    },
    isPopYuesao() {
      return this.skuTag == SKUTAG.POPYUSAO
    },
    isApplianceWash() {
      return this.skuTag == SKUTAG.APPLIANCE_WASHING
    },
    hasStore() {
      return SKUTAGNEED[this.skuTag] && SKUTAGNEED[this.skuTag].store
    },
    hasAddress() {
      return SKUTAGNEED[this.skuTag] && SKUTAGNEED[this.skuTag].address
    },
    hasWorker() {
      return SKUTAGNEED[this.skuTag] && SKUTAGNEED[this.skuTag].worker
    },
    hasTime() {
      return SKUTAGNEED[this.skuTag] && SKUTAGNEED[this.skuTag].time
    }
  },
  // watch: {
  //     async selectedWorker(val) {
  //         if (val && val.businessId) {
  //             const json = await this.$store.dispatch('getCoupon4Confirm', {
  //                 uid: this.$$cookie('uid'),
  //                 skey: this.$$cookie('skey'),
  //                 spuId: this.$route.params.spuId,
  //                 skuId: this.$route.query.skuId,
  //                 sortType: this.confirmProduct.skuInfo.level4CategoryId,
  //                 price: this.confirmProduct.priceInfo.price,
  //                 shopId: val.businessId || '',
  //                 sourceType: this.$$cookie('source') === 'android' || this.$$cookie('source') === 'ios' ? 1 : 2
  //             })
  //             if (json.code * 1 === 1) {
  //                 this.setConfirmCoupons(json.data)
  //             }
  //         }
  //     }
  // },
  filters: {
    userTypeText(userType) {
      return userType == 1 ? '育儿顾问' : '认证育儿师'
    }
  },
  methods: {
    ...mapMutations([
      'showActionSheet',
      'changeView',
      'setActionHeader',
      'setSelectedWorker',
      'setSelectedTime',
      'setSelectedCoupon',
      'setConfirmCoupons',
      'resetConfirmCoupons'
    ]),
    showCalendar() {
      // if(this.hasStore && !this.store.store_code) {
      //     this.$$toast('请先选择服务门店')
      //     return
      // } else if(this.workers_on.length <= 0 ){

      //     if(this.hasStore){
      //         this.$$toast('当前门店暂不提供服务，敬请期待')
      //     } else if(this.hasAddress){
      //         this.$$toast('当前区域暂不提供服务，敬请期待')
      //     }
      //     return
      // } else if(this.hasWorker && !this.selectedWorker.workerCode) {
      //     this.$$toast('请先选择服务人员')
      //     return
      // }
      if (!this.isValid(2)) {
        return
      }
      if (this.isPopYuesao || this.isApplianceWash) {
        this.datePickerValue = this.selectedTime
          ? new Date(this.selectedTime)
          : new Date()

        if (this.isApplianceWash) {
          let curDate = new Date()
          var nextDate = new Date(curDate.getTime() + 24 * 60 * 60 * 1000)
          this.datePickerMin = nextDate
        }

        this.datePickerShow = true
      } else {
        this.changeView('calendar')
        this.setActionHeader({
          title: '选择服务日期',
          show: false
        })
        // this.showActionSheet();
        this.$router.push({
          query: { ...this.$route.query, action: true, viewName: this.viewName }
        })
      }
      // 埋点
      this.$$tracker('110101', '20000', 21035, this.selectedTime)
    },
    showStore() {
      //埋点
      this.changeServicePopTrackParams &&
        this.$$newTrackClick(this.changeServicePopTrackParams)

      this.changeView('storeList')
      this.setActionHeader({
        title: '选择门店',
        show: false
      })

      this.$router.push({
        query: { ...this.$route.query, action: true, viewName: this.viewName }
      })
    },
    showWorker() {
      if (!this.isValid(1)) {
        return
      }
      this.changeView('confirmWorkers')
      this.setActionHeader({
        title: '选择服务人员',
        show: false
      })
      // this.showActionSheet();
      this.$router.push({
        query: { ...this.$route.query, action: true, viewName: this.viewName }
      })
      // 埋点
      this.changeServiceWorkerTrackParams &&
        this.$$newTrackClick(this.changeServiceWorkerTrackParams)

      const code = this.selectedWorker.workerCode || ''
      this.$$tracker('110101', '20000', 21033, code)
    },
    delteWorker() {
      const code = this.selectedWorker.workerCode
      this.setSelectedWorker({})
      // 清除选中的优惠券
      this.setSelectedCoupon({})
      this.resetConfirmCoupons()
      // 埋点
      this.$$tracker('110101', '20000', 21034, code)
    },
    async deleteTime() {
      const time = this.selectedTime
      this.setSelectedTime('')
      let areaCode = ''
      if (
        this.selectedAddress.regionid &&
        this.selectedAddress.regionid !== ''
      ) {
        areaCode = this.selectedAddress.regionid.split('_')[2]
      }
      // 获取服务人员
      console.log(555)
      await this.$store.dispatch('getWorkers', {
        spuId: this.$route.params.spuId,
        serviceDate: this.selectedTime,
        districtId: areaCode
      })
      // 埋点
      this.$$tracker('110101', '20000', 21036, time)
    },
    showAddress() {
      this.changeView('confirmAddress')
      this.setActionHeader({
        title: '选择地址',
        show: false
      })
      // this.showActionSheet();
      this.$router.push({
        query: { ...this.$route.query, action: true, viewName: this.viewName }
      })
      // 埋点
      const param = `${this.selectedAddress.province}|${this.selectedAddress.city}|${this.selectedAddress.district}`
      this.$$tracker('110101', '20000', 21032, param)
    },
    showCoupon() {
      this.changeView('coupon')
      this.setActionHeader({
        title: '优惠券',
        show: false
      })
      this.$router.push({
        query: { ...this.$route.query, action: true, viewName: this.viewName }
      })
    },
    deleteCoupon() {
      this.setSelectedCoupon({})
    },
    toScrollTop() {
      //ios 输入完成页面不回到正常位置问题修复
      try {
        setTimeout(() => {
          //并且焦点非输入框在回到顶部
          if (
            document.activeElement.tagName != 'INPUT' &&
            document.activeElement.tagName != 'TEXTAREA'
          ) {
            if (isIOS) {
              document.body.scrollTop = 0
              document.documentElement.scrollTop = 0
            }
          }
        }, 0)
      } catch (e) {}
    },
    isValid(type) {
      // 1:验证服务人员 2:验证服务时间
      const workerNum = this.workers_on.length //服务人员数量
      const storeCode = this.store.store_code //服务门店code
      if (type == 1) {
        if (workerNum == 0) {
          if (this.hasAddress && this.isSelectedAddress) {
            this.$$toast('此服务地址无满足条件的服务人员')
            return false
          } else if (this.hasAddress && !this.isSelectedAddress) {
            this.$$toast('请先选择服务地址')
            return false
          } else if (this.hasStore && storeCode) {
            this.$$toast('此门店无满足条件的服务人员')
            return false
          } else if (this.hasStore && !storeCode) {
            this.$$toast('请先选择服务门店')
            return false
          }
        }
      } else if (type == 2) {
        if (this.hasAddress && !this.isSelectedAddress) {
          this.$$toast('请先选择服务地址')
          return false
        } else if (this.hasStore && !storeCode) {
          this.$$toast('请先选择服务门店')
          return false
        } else if (
          ((this.hasAddress && this.isSelectedAddress) ||
            (this.hasStore && storeCode)) &&
          this.hasWorker &&
          !this.selectedWorker.workerCode
        ) {
          this.$$toast('请先选择服务人员')
          return false
        }
      }
      return true
    },
    datePickerConfirm(value) {
      function formatDate(date) {
        let year = date.getFullYear()
        let month = date.getMonth() + 1
        let day = date.getDate()
        month = month > 9 ? month : '0' + month
        day = day > 9 ? day : '0' + day
        return `${year}-${month}-${day}`
      }
      this.datePickerShow = false
      this.$store.commit('setSelectedTime', formatDate(value))
    },
    remarkInput(e) {
      // 高度随着输入行数而增大，最多两行
      const fontSize = parseFloat(document.documentElement.style.fontSize)
      e.target.style.height =
        Math.min(e.target.scrollHeight, 2 * 0.37 * fontSize) + 'px'
    }
  },
  components: {
    userprofile,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.confirm-serve-info {
  margin-bottom: rem(21px);
  padding: rem(10px) 0;
  border-radius: rem(16px);
  overflow: hidden;
  .iconfont {
    font-size: rem(40px);
  }
  .icon-jiantou {
    // color: #ccc;
    display: inline-block;
    transform: rotate(-90deg);
    font-size: rem(24px);
  }
  .user-remark-layout {
    padding-right: 0;
  }
  .user-remark {
    @include border(bottom, #f2f2f2, 0);
    align-items: flex-start;
    textarea {
      text-align: right;
      padding-right: rem(24px);
      margin-left: rem(20px);
      flex: auto;
      border: 0;
      line-height: rem(37px);
      height: rem(37px);
      color: #000000;
      font-size: rem(26px);
      resize: none;
    }
  }
  .invite-code {
    color: #000000;
    font-size: rem(26px);
    input {
      text-align: right;
    }
  }

  .worker-layout {
    align-items: flex-start;
    .icon-arr-r {
      display: block;
      flex: none;
      height: rem(36px);
    }
  }
  .has-selected-time-tip {
    position: relative;
    padding-bottom: rem(90px);
  }
  .selected-time-tip {
    position: absolute;
    font-size: rem(22px);
    color: #ff5900;
    line-height: rem(28px);
    bottom: rem(22px);
  }

  .item-common-content {
    .worker-pro-name {
      height: rem(36px);
    }
    .block {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      ul {
        display: flex;
        font-size: rem(22px);
        line-height: rem(28px);
        color: #262626;
        overflow: hidden;
        padding-left: rem(20px);
        li {
          padding-left: rem(13px);
          margin-left: rem(12px);
          position: relative;
          flex: none;
          @include ellicpsis;
          &:first-child {
            margin-left: 0;
          }
          &:nth-child(2) {
            flex: auto;
          }
          &:before {
            display: block;
            content: '';
            position: absolute;
            width: 2px;
            height: 2px;
            left: rem(6px);
            top: 50%;
            background-color: #000;
            transform: translateY(-50%);
          }
        }
      }
    }
  }
  .worker {
    display: flex;
    justify-content: space-between;
    padding-top: rem(24px);
    > label {
      flex: none;
      font-size: rem(22px);
      color: #808080;
      line-height: rem(28px);
    }
  }

  .item-cell {
    align-items: flex-start;
    &.item-common {
      align-items: stretch;
    }
    .item-cell-bd {
      display: flex;
      justify-content: flex-end;
    }
    &:first-child {
      .item-cell-bd {
        p:first-of-type {
          font-size: rem(32px);
          font-weight: 600;

          .phone {
            margin-left: rem(15px);
          }
        }
        p:last-of-type {
          margin-top: rem(15px);
          line-height: 1.5;
          color: #666;
        }
        p.empty-detail-address {
          font-weight: normal;
          margin: 0;
        }
      }
    }
    &:last-child {
      &::before {
        border: 0;
      }
    }
  }
  .item-cell-hd {
  }
  .yuerguwen {
    align-self: flex-start;
  }
  .chooseTime,
  .choose-person {
    display: flex;
    align-items: center;

    p {
      flex: 1;
      font-size: rem(26px);
      color: #000000;
    }
    .icon-roundclosefill {
      color: #ccc;
      font-size: rem(40px);
      margin-right: rem(20px);
    }
  }
  .choose-person {
    .avatar {
      position: relative;
      margin-right: rem(20px);
      width: rem(36px);

      img {
        width: rem(36px);
        height: rem(36px);
        border-radius: 50%;
      }
    }
    .name {
      font-size: rem(26px);
      color: #000000;
    }
    .user-profile {
      flex: 1;
    }
  }
  .chooseCoupon {
    display: flex;
    align-items: center;

    p {
      flex: 1;
    }
    .icon-roundclosefill {
      color: #ccc;
      font-size: rem(40px);
      margin-right: rem(20px);
    }

    .default {
      color: #999;
      font-weight: normal;
    }
    .haveCoupon {
      color: #ff397e;
    }
  }
  .default {
    color: #999;
  }
  ::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #999;
  }
}

.van-datetime-picker {
  /deep/ .van-picker__confirm {
    color: #ff5900;
  }
}
</style>
